import {PIXI} from '@colonist/pixi'

export function handleClickWithoutDragging(view: PIXI.Container, action: () => void) {
    const tolerance = 20
    let pointerDownPosition: PIXI.Point

    view.addListener('pointerdown', (e: PIXI.FederatedPointerEvent) => {
        pointerDownPosition = e.global
    })

    view.addListener('pointerup', (e: PIXI.FederatedPointerEvent) => {
        const mousePosition = e.global
        if(pointerDownPosition == undefined) return

        if(Math.abs(mousePosition.x - pointerDownPosition.x) > tolerance || Math.abs(mousePosition.y - pointerDownPosition.y) > tolerance) {
            return
        }

        action()
    })
}
